
import FileItem from './file-item.vue'
import {Uploader} from 'mixins'

export default {
  components: {FileItem},
  mixins: [Uploader],
}
